"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTH_FORMAT_OPTION = exports.DATETIME_FORMAT_OPTION = exports.BLOG_LANGUAGE = void 0;
var BLOG_LANGUAGE = 'BlogLanguage';
exports.BLOG_LANGUAGE = BLOG_LANGUAGE;
var DATETIME_FORMAT_OPTION = 'DateTimeFormatOption';
exports.DATETIME_FORMAT_OPTION = DATETIME_FORMAT_OPTION;
var MONTH_FORMAT_OPTION = 'MonthFormatOption';
exports.MONTH_FORMAT_OPTION = MONTH_FORMAT_OPTION;